import { gql } from '@apollo/client'

export default gql`
  fragment EmployeeDisplayShortInfo on EmployeeDisplayShortInfo {
    id
    firstName
    lastName
    currentLevel
    companyName
    buName
    avatarUrl
  }
`
